module.exports = "/images/icon-heart-filled.svg?e7f9b46d2a750a489f944acf5d462884";